<template>
    <div class="flex flex-col h-full relative">

        <div class="flex  w-full h-full items-center justify-center" v-if="!is_game_timed && gamer.current_question == gamer.max_questions">
            <div class="bg-red-300 p-4">
                {{ $t('islem_tahmin_gamer_wait_description') }}
            </div>
        </div>

        <main class="h-full flex flex-col items-center relative overflow-auto" v-else>
            <!-- soru -->
            <div class="flex flex-col w-full items-center justify-end font-bold">
                <!-- İlerleme -->

                <div class="flex flex-col w-1/2 pt-8">
                    <!-- ilerleme -->
                    <div class="flex space-x-2 w-full items-center justify-center" v-if="!is_game_timed">
                        <div class="text-right text-xl">{{ `${gamer.current_question + 1}/${max_questions}` }}</div>
                        <div class="flex w-full items-center justify-center">
                            <div class="w-full bg-gray-200 rounded-full h-2.5  ">
                                <div class="games-islem-tahmin-secondary-gridant h-2.5 rounded-full" :style='`width: ${((gamer.current_question + 1) * 100) / max_questions}%`'></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex items-center justify-center bg-white p-2 rounded-lg mt-4  shadow-lg" :class="`${phoneScreen.landscape ? 'sm:p-2 lg:p-4' : 'lg:p-4'}`">
                    <div class="flex flex-col space-y-1 items-end justify-center" :class="`${phoneScreen.landscape ? 'sm:space-y-1 lg:space-y-4' : 'lg:space-y-4'}`">
                        <div class="flex space-x-2 items-center" v-for="o,k1 in setAnswerArr" :key="k1">
                            <div v-for="a, k2 in o[0].arr" :key="k2">
                                <div class="flex items-center justify-center">
                                    <div  :class="getClass(a)" v-if="a.type == 'number'">
                                        {{a.showValue ? a.value : ''}}
                                        {{ a.active ? '?' : '' }}
                                    </div>
                                    <div :class="getClass(a)"  v-if="a.type == 'operation'">
                                        <img class="w-14 h-14" src="/img/games/islem_tahmin/topla.svg" alt="" v-if="a.value == 'topla'">
                                        <img class="w-14 h-14" src="/img/games/islem_tahmin/cikar.svg" alt="" v-if="a.value == 'cikar'">
                                        <img class="w-14 h-14" src="/img/games/islem_tahmin/bol.svg" alt="" v-if="a.value == 'bol'">
                                        <img class="w-14 h-14" src="/img/games/islem_tahmin/carp.svg" alt="" v-if="a.value == 'carp'">
                                        {{ a.active ? '?' : '' }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center justify-center text-3xl w-8 h-8 games-islem-tahmin-text-color-primary">=</div>
                            <div  :class="getClass('result')">
                                {{ o[0].showValue ? o[0].result : '' }}
                            </div>
                        </div>
                    </div>

                    <div class="flex items-center justify-center px-5" :class="phoneScreen.landscape ? 'sm:px-8 lg:px-10 ' : 'lg:px-10'">
                        <div class="flex flex-col item-center  items-center justify-center games-islem-tahmin-text-color-primary ">
                            <div class="text-xs" :class="phoneScreen.landscape ? 'sm:text-xs lg:text-sm ' : 'lg:text-sm'">{{ $t('islem_tahmin_title_target') }}</div>
                            <div class="text-3xl" :class="phoneScreen.landscape ? 'sm:text-3xl lg:text-5xl' : 'lg:text-5xl'">{{ target }}</div>
                            <div :class="phoneScreen.landscape ? 'sm:text-xs lg:text-sm ' : 'lg:text-sm'" v-if="notification?.praise">{{ notification?.praise }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!--numara ve işlem seçme alanı-->
            <div class="flex flex-col items-center justify-center pt-4">
                <div class="flex space-x-4">
                    <BgIcon svg="trash" :title="$t('islem_tahmin_title_button_clear')" @click="clearQuestion"  :class="getActiveIndex != 0 ? '':'opacity-30'" />
                    <BgIcon svg="back2" :title="$t('islem_tahmin_title_button_back')" @click="backFNC" :class="getActiveIndex == 0 ? 'opacity-30':''" />
                    <BgIcon svg="hint"  :title="$t('islem_tahmin_title_button_hint')" :number="maxHint - hint"  @click="hintFNC" :class="getActiveIndex != 0 && hint == 3 ? 'opacity-30':''" />
                    <BgIcon svg="next"  :title="$t('islem_tahmin_title_button_new_question')" @click="getQuestion" />
                </div>

                <div class="flex flex-col p-2 mt-2" :class="`${!numara_goster ? 'flex-col-reverse' : ''} ${phoneScreen.landscape ? 'sm:mt-2 lg:mt-4' : 'lg:mt-4'}`">
                    <div class="flex space-x-2 items-center justify-center mb-4">
                        <BgOperation
                        class="p-1 lg:p-2 font-bold rounded-lg"
                        :class="!islem_goster ? 'opacity-40 h-9 w-9 lg:h-12 lg:w-12' : 'w-16 h-16 lg:h-18 lg:w-18'"

                        v-for="o, key in operations.filter(i => i.visible).length == 0 ? operations : operations.filter(i => i.visible)" :key="key"
                            @click="islem_goster && clickIslem(o)"
                        >
                            <img :src="o.icon" class="w-full h-full" alt="">
                        </BgOperation>
                    </div>

                    <div class="flex justify-center item-center space-x-2 mb-4">
                        <BgOperation
                            class="lg:text-2xl lg:p-2 text-xl p-1 font-bold rounded-full"
                            :class="!numara_goster ? 'opacity-40 h-12 w-12 lg:h-12 lg:w-12' : 'w-16 h-16 lg:w-18 lg:h-18 '"
                            v-for="c in choices.filter(i => !selected.includes(i.number))"
                            :key="c.number"
                            @click="numara_goster && clickNumber(c)">
                            {{ c.number }}
                        </BgOperation>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script setup>
import {ref, watch, onMounted, computed} from "vue"
import useSound from '../../sounds'
import {useScreen} from 'vue-screen'
import BgIcon from '../other/BgIcon.vue'
import BgOperation from '../other/BgOperation.vue'
import i18next from 'i18next'

const emit  = defineEmits(['screen', 'add_point'])
const props = defineProps(['gamer', 'volume', 'time', 'operations', 'hard', 'is_game_timed', 'gamer_count', 'max_questions'])
const choices = ref([])
const notification = ref([])
const selectedAnswer = ref(null);
const {soundStart, soundSetVolume} = useSound({files_url:i18next.t('files_url')})

const isGameTimed       = ref(props.is_game_timed)
const phoneScreen = useScreen()
const lenWrong          = ref(0)
const timeWrong         = ref(0)
const target            = ref(null)
const secilen_numaralar = ref([])
const answer            = ref(0)
const secilen_islem     = ref(false)
const numara_goster     = ref(true)
const islem_goster      = ref(false)
const answerArr         = ref([])
const selected          = ref([])
const selectedItem      = ref(null)
const maxHint           = ref(3)
const hint              = ref(0)

const start = () => getQuestion()

soundSetVolume(props.volume)
onMounted(() => start())


const clickNumber = (c) =>{
    //soundStart(2)
    selected.value[selectedItem.value.index] = c.number
    numara_goster.value = false
    islem_goster.value = true
}


const clickIslem = (o) => {
    selected.value[selectedItem.value.index] = o.title
    islem_goster.value  = false
    numara_goster.value = true
}


watch(props, (props, _) => {
    if (timeWrong.value - props.time > 3 && timeWrong.value > 0) {
        lenWrong.value = 0
        timeWrong.value = 0
        notification.value = {
            praise: i18next.t('islem_tahmin_info_continue'),
            point: 0
        }
    } else {
        if (timeWrong.value > 0) {
            const remainingTime = (4 - (timeWrong.value - props.time));
            if (remainingTime < 4) {
                notification.value = {
                    praise: i18next.t('islem_tahmin_info_wait', {time: remainingTime}),
                    point: 0
                }
            }
        }
    }
})


const setAnswer = (status) => {
    const notificationArr = []
    notificationArr.push(i18next.t('islem_tahmin_info_notification_1'))
    notificationArr.push(i18next.t('islem_tahmin_info_notification_2'))
    notificationArr.push(i18next.t('islem_tahmin_info_notification_3'))
    notificationArr.push(i18next.t('islem_tahmin_info_notification_4'))
    selectedAnswer.value = answer;

    if (status) {
        soundStart(0)
        lenWrong.value = 0

        const period = (props.gamer.bestAnswer + 1) % 4;
        const newPoint = period == 0 ? 30 : 10;
        const newGamer = {
            ...props.gamer,
            bestAnswer: props.gamer.bestAnswer + 1,
            point: props.gamer.point + newPoint,
            true: props.gamer?.true + 1,
            max_questions: props.max_questions,
            appear_qestion: props.gamer.appear_qestion + 1
        }

        emit('add_point', {...newGamer})

        const notificationKey = newGamer.bestAnswer > notificationArr.length ? notificationArr.length - 1 : newGamer.bestAnswer - 1;

        notification.value = {
            praise: notificationArr[notificationKey],
            point: newPoint
        }

        setTimeout(() => getQuestion(), 1000);
    } else {
        soundStart(1)
        const newGamer = {
            ...props.gamer,
            bestAnswer: 0,
            appear_qestion: props.gamer.appear_qestion + 1
        }

        emit('add_point', newGamer)
        notification.value = {
            praise: i18next.t('islem_tahmin_info_error'),
            point: 0
        }


        clearQuestion();
    }

}

const clearQuestion = () => {
    if (getActiveIndex.value == 0) return

    let choicesMap = choices.value.map(i => {
            i.status = true
            return i
        })

        choices.value           = choicesMap
        answer.value            = 0
        secilen_islem.value     = false

        choices.value = choices.value.filter(i => i.current).map(i => {
            i.show = true
            i.status = true
            return i;
        })

        numara_goster.value     = true
        islem_goster.value      = false

        selected.value = [...selected.value.map((i, key) => key % 2 ? '-' : -9999)];

}

const hintFNC = () => {
    if (getActiveIndex.value > 0) return
    if (hint.value > maxHint.value - 1) return

    hint.value++
    clearQuestion();

    selected.value[0] = answerArr.value[0]
    selected.value[1] = answerArr.value[1]
}

const backFNC = () => {
    if (getActiveIndex.value == 0) return

    let value = selected.value[getActiveIndex.value - 1]

    if (Number.isInteger(value)) selected.value[getActiveIndex.value - 1] = -9999
    else selected.value[getActiveIndex.value - 1] = '-'


    numara_goster.value = false
    islem_goster.value = false

    setTimeout(() => {
        numara_goster.value = selectedItem.value.type == "number"
        islem_goster.value  =  selectedItem.value.type == "operation"
    }, 100);
}

const setScreen = (screen) => {
    emit('screen', screen)
}


const reset = () => {
    notification.value = []
    target.value = null
    secilen_numaralar.value = []
    answer.value            = 0
    secilen_islem.value     = false

    numara_goster.value   = true
    islem_goster.value    = false
}



const findDivisors = (number) => {
    var divisors = [];
    for (var i = 1; i <= number; i++) {
    if (number % i === 0) {
        divisors.push(i);
    }
    }
return divisors;
}




const getQuestion =  async () => {
    reset();

    let deneme_sayisi = 1000;


    emit('add_point', {
        ...props.gamer,
        current_question: props.gamer.current_question + 1,
    })

    for await (const num of [...Array(deneme_sayisi).keys()]) {
        let newTarget = setTarget()
        if (newTarget < 101 && newTarget > 1) {
            target.value  = newTarget
            choices.value = shuffle([...secilen_numaralar.value])
            break;
        }

        if (num == deneme_sayisi - 1) {
            target.value  = newTarget
            choices.value = shuffle([...secilen_numaralar.value])
            break;
        }

    }
}



const setTarget =  () => {
    let hardQuestionCount = [2,3,4];
    let hardNumberSize  = [10, 20, 30]
    let operations = props.operations.filter(i => i.visible);
    operations = operations.length == 0 ? props.operations : operations;

    let hardArr = shuffle(Array.from({ length: hardNumberSize[props.hard] }, (_, index) => index + 1));

    secilen_numaralar.value = []
    for (let i = 0; i < hardQuestionCount[props.hard]; i++) {
        let number = hardArr[i];
        if (operations.filter(i => i.title  == "bol").length == operations.length && i == 0) {
            hardArr.map(i => {
                if (findDivisors(i) > hardQuestionCount[props.hard]) number = i
            })
        }

        secilen_numaralar.value.push({
            number: number,
            status: true,
            show: true,
            current: true,
            key: new Date().getTime() + i
        })
    }


    let arr = []
    let _target = secilen_numaralar.value[0].number;
    arr.push(_target)
    for (let i = 0; i < secilen_numaralar.value.length - 1; i++) {
        const randomOperationsIndex = Math.floor(Math.random() * operations.length);
        if(operations[randomOperationsIndex].title == "topla"){
            _target = _target + secilen_numaralar.value[i + 1].number
        }else if(operations[randomOperationsIndex].title == "cikar"){
            _target = _target - secilen_numaralar.value[i + 1].number
        }else if(operations[randomOperationsIndex].title == "carp"){
            _target = _target * secilen_numaralar.value[i + 1].number
        }else if(operations[randomOperationsIndex].title == "bol"){
            if (_target % secilen_numaralar.value[i + 1].number == 0) {
                _target = _target / secilen_numaralar.value[i + 1].number
            }else{

                //let bolenler = shuffle(findDivisors(_target))
                let bolenler = findDivisors(_target).filter(i =>  i != _target && !secilen_numaralar.value.map(x => x.number).includes(i))

                if (bolenler.length > 1) {
                    let newNumber = shuffle(bolenler)[0]
                    secilen_numaralar.value[i + 1].number = newNumber
                    _target = _target / newNumber
                }else{
                    return 1001
                }
            }
        }

        arr.push(operations[randomOperationsIndex].title)
        arr.push(secilen_numaralar.value[i + 1].number)
    }


    answerArr.value = [...arr];
    selected.value = [...arr.map((i, key) => key % 2 ? '-' : -9999)];

return _target;
}

const isFloat = (n) => {
    return Number(n) === n && n % 1 !== 0;
}

const shuffle = (array) => {
    let currentIndex = array.length, randomIndex;
    // While there remain elements to shuffle...
    while (currentIndex != 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
    return array;
}


const getActiveIndex = computed(() => {
    return selected.value.findIndex(i => i == "-" || i == -9999)
})



const setAnswerArr = computed(() => {

    //arr => [26, 'carp', 13, 'topla', 12, 'bol', 175]
    let arr = [...selected.value];
    let activeIndex = getActiveIndex.value
    //let arr = [...answerArr.value];
    let otherArr = arr.splice(1, arr.length);
    let target = arr[0]
    let lastArr = []
    let index = 0;
    for (let i = 0; i < otherArr.length; i++) {

        if (["topla", "bol", "cikar", "carp", "-"].includes(otherArr[i])) {
            let subArr = []
            let subObj = {}
            subObj.arr = [
                        {value: roundToTwoDecimal(target), canChosen: (i == 0),  type: 'number', active: activeIndex == 0 && activeIndex == index, index: activeIndex == 0 ? activeIndex : false, showValue: activeIndex > index || activeIndex == -1},
                        {value: otherArr[i], canChosen: true, type: 'operation', active: activeIndex == i + 1, index: i + 1, showValue: activeIndex > i + 1 || activeIndex == -1},
                        {value: roundToTwoDecimal(otherArr[i + 1]), canChosen: true, type: 'number', active: activeIndex == i + 2, index: i + 2, showValue: activeIndex > i + 2 || activeIndex == -1}
                    ]

            if (otherArr[i] == "topla") target = target + otherArr[i + 1];
            else if (otherArr[i] == "cikar") target = target - otherArr[i + 1];
            else if (otherArr[i] == "bol") target = target / otherArr[i + 1];
            else if (otherArr[i] == "carp") target = target * otherArr[i + 1];

            subObj.showValue = subObj.arr.filter(i => i.value == '-' || i.value == -9999).length == 0;
            subObj.result = roundToTwoDecimal(target);
            subArr.push(subObj)
            lastArr.push(subArr)

            let isActiveArr = subObj.arr.filter(i => i.active)
            if (isActiveArr.length > 0) {
                selectedItem.value = isActiveArr[0]
            }
        }
        index++;
    }


    return lastArr
})

const roundToTwoDecimal = (number) => {
    // Sayıyı 100 ile çarparak iki basamağa kadar olan kısmı elde ederiz.
    var roundedNumber = Math.round(number * 100);

    // İki basamağa yuvarlanmış sayıyı 100'e böleriz.
    return roundedNumber / 100;
}

watch(getActiveIndex, (cIndex) => {
    if (cIndex == -1) {
            islem_goster.value = false
            numara_goster.value = false

            setAnswer(setAnswerArr.value[setAnswerArr.value.length - 1][0].result == target.value)
    }
})

const getClass = (item) => {
    let g = "flex items-center justify-center p-1 border-2 games-islem-tahmin-border-color w-8 h-8 text-xs lg:text-lg ";
    g += phoneScreen.landscape ? 'sm:w-8 lg:w-12 lg:h-12 lg:p-3' : 'lg:w-12 lg:h-12 lg:p-3'
    let bgColor = "bg-gray-200"

    if(item == 'result') return `${bgColor} ${g} rounded-full`

    if(item.active) g += " cursor-pointer opacity-100"
    if(item.canChosen && !item.active && (item.value == "-" || item.value == -9999))
        g += " opacity-100 "

    //if (!item.canChosen) bgColor = "bg-secondary"
    if (item.active) {
        bgColor = " games-islem-tahmin-rounded-gridant-secondary "
    }
    if (item.type == 'number') {
        g += " rounded-full "
    }
    if (item.type == 'operation') {
        g += " rounded-lg "
    }

    return `${bgColor} ${g}`
}
</script>
